import { CSSProperties, useEffect, useState } from "react";
import { Modal } from "../../../../../Modal/Default/Index";
import { ButtonOnlyTitle } from "../../../../../Buttons/ButtonOnlyTitle/Index";
import { useTaskCreation } from "../../../../../../hooks/useTaskCreation";
import { RoundedCloseButton } from "../../../../../Buttons/RoundedCloseButton/Index";
import { ReactComponent as CheckComplete } from "../../../../../../assets/svg/icons/CheckFull.svg";
import axios from "../../../../../../services/axios"
import { useFilter } from "../../../../../../hooks/useFilter";

const createEvaluatorModalStyle = {
  padding: "50px",
  width: "600px",
  height: "fit-content",
  borderRadius: 20,
  position: "relative"
} as CSSProperties;

export default function ArchiveEvaluation() {
  const { modalArchiveEvaluation, setModalArchiveEvaluation, taskId } = useTaskCreation();
  const { reloadTasks, setReloadTasks } = useFilter()

  return (
    <>
      <Modal
        visible={modalArchiveEvaluation}
        contentStyle={createEvaluatorModalStyle}
      >
        <div className="closeButton__startEvaluation">
          <RoundedCloseButton
            onClick={() => setModalArchiveEvaluation(false)}
          />
        </div>
        <section className="body__startEvaluation">
          <header>
            <h2 className="title__startEvaluation">Arquivar avaliação</h2>
            <span className="description__startEvaluation">Ao arquivar a avaliação sera possivel solicitar uma nova avaliação de pastagem para este respectivo pasto.</span>
          </header>
          <footer className="footerCreateEvaluator">
            <ButtonOnlyTitle
              title="Cancelar"
              theme="light"
              type="button"
              onClick={() => {
                setModalArchiveEvaluation(false)
                setReloadTasks(0)
              }}
            />
            <ButtonOnlyTitle
              title="Arquivar"
              theme="info"
              type="button"
              onClick={() => {
                axios.put(`/tasks/archive/${taskId}`).finally(() => {
                  setModalArchiveEvaluation(false)
                  setReloadTasks(taskId)
                })
              }}
            />
          </footer>
        </section>
      </Modal>
    </>
  )
}